import { useEffect } from "preact/hooks";
import { animator } from "../anim";

let requestors = 0;

// use for manual control of the animator only in components that need it
// in order to avoid permanent animation loop
//
const useAnimator = () => {
    useEffect(() => {
        ++requestors;

        if (!animator.isStarted()) {
            animator.start();
        }

        return () => {
            --requestors;

            if (requestors === 0) {
                animator.stop();
            }
        };
    }, []);

    return animator;
};

export default useAnimator;
